module.exports = __webpack_public_path__ + "img/image.7395652f.svg";